import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export type ProducerResumeTransactions = {
  total_pages: number
  transactions: BankTransaction[]
}

interface BankTransaction {
  id: number
  account: string
  agency: string
  bank_name: string
  bank_number: string
  date: string
  description: string
  event_name: string
  identifier: string
  receiver: string
  receiver_registration: string
  status: string
  type: string
  value: string
}

export interface TrackerResponse {
  resumeTransactions: ProducerResumeTransactions
  resumeLoadingTransactions: boolean
  resumeErrorTransactions: string | null
}

export const useGetProducerResumeTransactions = (
  start: string,
  end: string,
  page: number,
  active: string
): TrackerResponse => {
  const url: string = `producer/analytics/finacialResumeTransactions?start=${end}&end=${start}&page=${page}&active=${active}`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data?.data || {}, [data])
  const memoizedValue = useMemo(
    () => ({
      resumeTransactions: nestedData,
      resumeLoadingTransactions: isLoading,
      resumeErrorTransactions: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
